import Checklist from "./Checklist";
import IconCheck from "ui/icons/IconCheck";
import IconCircle from "ui/icons/IconCircle";

## Basic Usage

<Checklist items={["First item", "Second item", "Third item"]} />

---

## Feature List

<Checklist
  items={[
    "Unlimited projects",
    "Priority support",
    "Advanced analytics",
    "Custom integrations",
    "Team collaboration",
  ]}
/>

---

## Custom Icon

<div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
  <div>
    <p style={{ marginBottom: "0.5rem" }}>**Circle bullets:**</p>
    <Checklist items={["Item one", "Item two", "Item three"]} icon={<IconCircle size={8} fill="currentColor" />} />
  </div>
  <div>
    <p style={{ marginBottom: "0.5rem" }}>**Colored checks:**</p>
    <Checklist items={["Completed task", "Another done", "All finished"]} icon={<IconCheck size={12} color="emerald" />} />
  </div>
</div>

---

## Requirements List

<Checklist
  items={[
    "Node.js 18 or higher",
    "npm or yarn package manager",
    "Git version control",
    "Code editor (VS Code recommended)",
  ]}
/>


